module.exports = __webpack_public_path__ + "media/images/flags/16/South-Georgia-and-the-South-Sandwich-Islands-a084fd0336349b94d763d9cca5d9de5f.png";